exports.value = "v3.0.0-GA";